import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "./loading.css";

function Loading() {
  return (
    <div className="_loadingComponent">
      <CircularProgress />
    </div>
  );
}

export default Loading;
